import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from '../styles/ticket.module.css'
import StateContext from '../context/state/StateContext'
import UserContext from '../context/user/UserContext'
import Status from './Status'
import axios from 'axios'
import { toast } from 'react-toastify'
import SideContent from './SideContent'
import { LuCalendarClock } from "react-icons/lu";
import SupportSideContent from './SupportSideContent'


const RequestList = ({ data, index }) => {

    const {  setDetail, detail, token } = useContext(StateContext);
    const { user } = useContext(UserContext)
    const [ detailModal, setDetailModal ] = useState(false)
    const [userBy, setUserBy] = useState('')

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, options);
    };


    const statusColor = () => {
        switch (data?.status?.toLowerCase()) {
            case "generated":
                return "#87CEEB"; // Orange (Indicates new request)
            case "in progress":
                return "#007BFF"; // Blue (Indicates ongoing work)
            case "completed":
                return "#28A745"; // Green (Indicates success)
            case "closed":
                return "#6C757D"; // Gray (Indicates closed case)
            case "accepted":
                return "#90EE90"; // Gray (Indicates closed case)
            case "approved":
                return "#90EF90"; // Gray (Indicates closed case)
            default:
                return "#007BFF"; // Red (For unknown status or error)
        }
    };
    

    const getByID = async (id, setUser) => {
        try {

            const response = await axios.get(process.env.REACT_APP_API_URL + `api/auth/getById/${id}`,
                {
                    headers: {
                        'content-type': 'application/json',
                        'auth-token': `${token}`
                    }
                }
            )

            const json = response.data;
            if (json.success) {
                setUser(json.user)
            } else {
                // console.log(json.message || json.error);
                toast.error(json.message || json.error)
            }

        } catch (error) {
            toast.error(error)
        }
    }

    useEffect(() => {
        if(data){
            getByID(data.generatedById, setUserBy)
        }
    }, [data])

   
    return (
        <>
            <div className={styles.item} onClick={() => { setDetailModal(true); setDetail({ open: true, detail: data }) }}>
                <div className={styles.item__details}>
                    <h3 className={styles.item__title}>{data.title}</h3>
                    <ul>
                        <li><b>Request No</b>. : {data.id}</li>
                        <li><b>Agency </b>: {data.agency}</li>
                        <li>
                        {data.deadline && `Deadline : ${data.deadline}`}
                        </li>
                        {/* <li className='d-flex flex-wrap'><b>Assigned To</b>. :
                            <div className={styles.listUser}>
                                {data.users && data.users.map((item, index) => {
                                    return <div className={styles.user}>
                                        {item.picture ? <img src={process.env.REACT_APP_API_URL + `uploads/${item.picture}`} className='img-fluid' alt="" /> : <i className={`bx bxs-user-circle ${styles.img}`}></i>}
                                        <p>{item.username}</p>
                                    </div>
                                })}
                            </div>
                        </li> */}
                    </ul>
                    {(user.role === "admin" || data.generatedById === user.id) && data.status !== "completed" && data.request_delay === "requested" ? <div className={styles.btns}>
                        <button
                            className={styles.button}
                        >
                            <LuCalendarClock color="orange" />
                            <span style={{color: "orange"}}>Requested for Delay</span>
                        </button>
                    </div> : null}
                </div>
                <div className={styles.item__rip} style={{ background: statusColor() }}></div>
                <div className={styles.item__price} style={{ background: statusColor() }}>
                    <div className='d-flex align-items-center justify-content-center flex-column'>
                        <span className={styles.heading}>Status</span>
                        <span className={styles.price}>{data.status}</span>
                        <span className={styles.heading}>{data.status == "completed" ? formatDate(data.updated_at) : null}</span>
                    </div>
                </div>
            </div>
            <SupportSideContent data={data} open={detailModal} close={setDetailModal} />
        </>
    )
}

export default RequestList



